import { VISUAL } from "../config/visualConfig";

export class ViewOrbit {
  yaw = 0;
  pitch: number = VISUAL.cameraPitch;

  rotate(x: number, y: number, seconds: number): void {
    const magnitude = Math.hypot(x, y);
    if (!Number.isFinite(magnitude) || magnitude <= 0.18) return;
    const strength = (Math.min(1, magnitude) - 0.18) / 0.82;
    const step = strength * Math.max(0, Math.min(0.1, seconds)) * 1.05;
    this.yaw += x / magnitude * step;
    this.yaw = Math.atan2(Math.sin(this.yaw), Math.cos(this.yaw));
    this.pitch = Math.max(Math.PI / 18, Math.min(Math.PI / 3, this.pitch + y / magnitude * step));
  }

  reset(): void { this.yaw = 0; this.pitch = VISUAL.cameraPitch; }
}
